import React, { SVGProps } from "react";
import { LinkIcon } from "@heroicons/react/outline";

export type IconType = "outline" | "solid";

export interface IconProps extends SVGProps<SVGSVGElement> {
  type?: IconType;
  name: any;
}

export default function Icon({ name, type = "solid", ...rest }: IconProps) {
  const Element = LinkIcon;

  return <Element {...rest} className="w-5 h-5 text-white" />;
}